import React from "react";
import {
  Pagination,
  PaginationItem,
  Select,
  MenuItem,
  Typography,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import "./customPagination.css"


// CustomPagination component handles pagination UI with optional rows-per-page selector
const CustomPagination = ({
  count, // Total number of pages
  page, // Current page (zero-based)
  rowsPerPage, // Number of rows per page (if used)
  onPageChange, // Function to handle page change
  onRowsPerPageChange, // Function to handle rows-per-page change
  fullData, // Full data object (used to display total records)
}) => {
  const totalRecords = fullData?.total_records || 0;
  const startRecord = page * rowsPerPage + 1;
  const endRecord = Math.min(startRecord + rowsPerPage - 1, totalRecords);

  return (
    <div className="pagination-wrapper">
      {/* Left section */}
      <div className="pagination-left">
        <span className="pagination-label">Page</span>
        <Select
          value={page + 1}
          onChange={(e) => onPageChange(null, e.target.value - 1)}
          size="small"
          className="page-select"
        >
          {Array.from({ length: count }, (_, i) => (
            <MenuItem key={i + 1} value={i + 1}>
              {i + 1}
            </MenuItem>
          ))}
        </Select>

        <Typography variant="body2" className="page-info">
            Showing {startRecord}- {endRecord} results of {totalRecords}
        </Typography>
      </div>

      {/* Right section */}
      <Pagination
        count={count}
        page={page + 1}
        onChange={(_, value) => onPageChange(_, value - 1)}
        shape="rounded"
        renderItem={(item) => (
          <PaginationItem
            {...item}
            className={`pagination-button ${item.selected ? "selected" : ""}`}
            slots={{
              previous: () => (
                <div className="arrow-wrapper">
                  <ArrowBackIcon fontSize="small" />
                  <span>Previous</span>
                </div>
              ),
              next: () => (
                <div className="arrow-wrapper">
                  <span>Next</span>
                  <ArrowForwardIcon fontSize="small" />
                </div>
              ),
            }}
          />
        )}
      />
    </div>
  );
};

export default CustomPagination;
